import React from "react";
import "./App.css";
import "./common/primary.css";
import "./common/grid.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorComponent from "./components/Error Component/ErrorComponent";
import AgentSAIF from "./pages/AgentSAIF";

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AgentSAIF />} />
          <Route path="*" element={<ErrorComponent />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
